import ThemeAttachment from '../theme-attachment';

/**
 * Create the action
 */

const { thunk, request, success, error } = ThemeAttachment.destroy(({ themeId, attachmentId }, fetch) => {
    return fetch.delete(`/themes/${themeId}/attachments/${attachmentId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };